import { render } from "./PenSetting.vue?vue&type=template&id=49a07c90"
import script from "./PenSetting.vue?vue&type=script&lang=js"
export * from "./PenSetting.vue?vue&type=script&lang=js"

import "./PenSetting.vue?vue&type=style&index=0&id=49a07c90&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__